var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MainHeader'),_c('Tabbar'),_c('keep-alive',{attrs:{"include":"Singer,Search"}},[_c('router-view')],1),_c('Player')],1)}
var staticRenderFns = []

export { render, staticRenderFns }